export default "__VITE_ASSET__YD1oWIPv__"